import PropTypes from 'prop-types';
import { Box, Button, Stack } from '@mui/material';

import { EmptyListOverlay, Loader } from 'components/simple';

import { UserMobileCard } from './UserMobileCard';

export const MobileUsersCards = ({
  users,
  customActionStyles = {},
  onLoadMore = null,
  isLoading = false,
  hasMore = false,
  itemsName,
}) => {
  if (!users.length) {
    return <EmptyListOverlay itemsName={itemsName} />;
  }

  return (
    <Stack spacing={3} alignItems="center">
      <Box
        width="100%"
        display="grid"
        gridTemplateColumns={{ xs: '1fr', sm: 'repeat(2, 1fr)', md: 'repeat(3, 1fr)' }}
        alignItems="start"
        gap={{ xs: 1, sm: 2 }}
      >
        {users.map(({ id, isInactive, actions, mobileInfo }) => (
          <UserMobileCard
            key={id}
            isInactive={isInactive}
            actions={actions}
            mobileInfo={mobileInfo}
            customActionStyles={customActionStyles}
          />
        ))}
      </Box>

      {isLoading && <Loader />}

      {onLoadMore && hasMore && !isLoading && (
        <Button size="small" variant="outlined" onClick={onLoadMore}>
          Load more
        </Button>
      )}
    </Stack>
  );
};

const actionPropTypes = {
  label: PropTypes.string.isRequired,
  icon: PropTypes.node,
  onClick: PropTypes.func,
  link: PropTypes.string,
  hideOption: PropTypes.bool,
};

const mobileInfoPropTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.node,
};

MobileUsersCards.propTypes = {
  users: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      isInactive: PropTypes.bool,
      actions: PropTypes.arrayOf(
        PropTypes.shape({
          ...actionPropTypes,
          subItems: PropTypes.arrayOf(PropTypes.shape(actionPropTypes)),
        }),
      ).isRequired,
      mobileInfo: PropTypes.shape({
        generalInfo: PropTypes.arrayOf(PropTypes.shape(mobileInfoPropTypes)),
        additionalInfo: PropTypes.arrayOf(PropTypes.shape(mobileInfoPropTypes)),
      }),
    }),
  ).isRequired,
  customActionStyles: PropTypes.shape({
    option: PropTypes.oneOfType([PropTypes.shape({}), PropTypes.func]),
  }),
  onLoadMore: PropTypes.func,
  isLoading: PropTypes.bool,
  hasMore: PropTypes.bool,
  itemsName: PropTypes.string.isRequired,
};
